module.exports = __webpack_public_path__ + "static/media/icon-partners.7c75555d.svg";